import { Component } from '@angular/core';
import {LayoutService} from '../layout/layout.service';

@Component({
    selector: 'my-page-layouts',
    styles: [],
    template: `<router-outlet></router-outlet>`
})

export class PageLayoutsComponent {    
        private layout: LayoutService
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/page-layouts.component.ts